// NotifyConfig.js
import { toast } from "react-toastify";
import i18n from "i18next";
import { normalizeAuthError } from "./authError";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const baseConfig = {
  closeButton: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  pauseOnFocusLoss: false,
  position: "top-center",
  hideProgressBar: true,
  autoClose: 5000, // UX-10: was 30s — toasts lingered far too long
  newestOnTop: true,
};

const NotifyConfig = {
  notifySuccess: (text) => {
    toast.success(text, {
      ...baseConfig,
      icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
      style: { background: "green", color: "#fff" },
    });
  },

  notifyError: (text) => {
    toast.error(text, {
      ...baseConfig,
      icon: <CloseCircleOutlined style={{ color: "#fff" }} />,
      style: { background: "#ff4d4f", color: "#fff" },
    });
  },

  // UX-10: honor the fallback argument callers already pass (e.g. Login) so a null/
  // undefined server message renders the fallback text instead of the literal "undefined".
  notifyErrorServer: (text, fallback) => {
    const message = normalizeAuthError(
      { response: { data: { detail: text } } },
      fallback || i18n.t("common.errorTitle"),
    );
    toast.error(message, {
      ...baseConfig,
      icon: <CloseCircleOutlined style={{ color: "#fff" }} />,
      style: { background: "#ff4d4f", color: "#fff" },
    });
  },

  notifyWarning: (text) => {
    toast.warning(text, {
      ...baseConfig,
      icon: <WarningOutlined style={{ color: "#faad14" }} />,
    });
  },

  notifyText: (text) => {
    toast(text, {
      ...baseConfig,
      icon: <InfoCircleOutlined style={{ color: "#1890ff" }} />,
    });
  },
};

export default NotifyConfig;
